import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import * as _ser from '../../../_redux/_services/JobPostingSlice';
import { GetUserId, getUserDetails } from '../../../_utilities/getUserInfo';
import PostingsComponent from '../PostingsComponent';

const initalState = { data: null, message: '', isloader: true };

const PostingsCreate = ({
  isJobDetails = false,
  cloneJob = null,
  onReceiveData,
  onResetValue,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(false);
  const [viewJob, setViewJob] = useState(
    JSON.parse(JSON.stringify(initialDetails))
  );
  const Addjobpostingscode = useSelector((state) => state.Addjobpostings.data);

  // Check if we came with parsed data from Upload JD panel
  const parsedData = location.state?.parsedData;

  useEffect(() => {
    if (cloneJob) {
      setViewJob(cloneJob);
    } else if (parsedData) {
      // If we have parsed data from Upload JD panel, merge it with initial details
      // Build custom fields from parsed data (e.g., Gender, Experience)
      const customFieldEntries = [];
      if (parsedData.gender) {
        customFieldEntries.push({ key: 'Gender', value: parsedData.gender });
      }
      if (parsedData.experience) {
        customFieldEntries.push({ key: 'Experience', value: parsedData.experience });
      }

      const mergedData = {
        ...initialDetails,
        jobTitle: parsedData.jobTitle || '',
        workModel: parsedData.workModel || '',
        jobType: parsedData.jobType || '',
        payBillRate: parsedData.payBillRate || '',
        location: parsedData.location || '',
        primarySkills: parsedData.primarySkills || '',
        secondarySkills: parsedData.secondarySkills || '',
        jobDesc: parsedData.jobDesc || '',
        externalSystemID: parsedData.externalSystemID || '',
        priority: parsedData.priority || '',
        jobDescForSM: parsedData.socialMediaJD || '',
        customFields: customFieldEntries.length > 0 ? JSON.stringify(customFieldEntries) : '',
      };
      setViewJob(mergedData);

    } else {
      dispatch(_ser.getListofQuestionsStartReducer(initalState));
    }
  }, [cloneJob, parsedData]);

  const GetValidData = async (data) => {
    const userInfo = await getUserDetails();
    const userId = await GetUserId();
    let emails = data.listofRecruitersemails;
    let formData = new FormData();
    formData.append('jobTitle', data.jobTitle);
    formData.append('externalSystemID', data.externalSystemID);
    formData.append('workModel', data.workModel);
    formData.append('jobStatus', data.jobStatus);
    formData.append('jobType', data.jobType);
    formData.append('clientId', data.clientId);
    formData.append('clientBillRate', data.clientBillRate);
    formData.append('payBillRate', data.payBillRate);
    formData.append('location', data.location);
    formData.append('locationDetails', data.locationDetails);
    formData.append('manager', data.manager);
    formData.append('teamLead', data.teamLead);
    formData.append('recruiters', data.recruiters);
    emails.forEach((item) => {
      formData.append(
        Object.keys(item)[0],
        JSON.stringify(item[Object.keys(item)])
      );
    });
    formData.append('priority', data.priority);
    formData.append('segmentId', data.segmentId);
    formData.append('jobDesc', data.jobDesc);
    formData.append('primarySkills', data.primarySkills);
    formData.append('secondarySkills', data.secondarySkills);
    formData.append('jobDescForSM', data.jobDescForSM);
    formData.append('customFields', data.customFields);
    formData.append('userId', userInfo.userId);
    formData.append('userFirstName', userInfo.firstName);
    formData.append('userLastName', userInfo.lastName);
    formData.append('customerId', userId);
    formData.append('ATSPortal', 1);
    formData.append('VSPortal', 0);
    formData.append('CSPortal', 0);
    formData.append('IPortal', 0);
    formData.append('EPortal', 0);
    formData.append('JBPortal', 0);
    formData.append('source', 1);
    formData.append('isClientConfidential', data.isClientConfidential);
    formData.append('endClientId', data.endClientId || '');
    formData.append('isEndClientConfidential', data.isEndClientConfidential || 0);
    // formData.append("parsedJD", data.parsedJD);
    if (isJobDetails === false) {
      dispatch(_ser.addjobpostingsAsync(formData, true));
      setDisableSubmitBtn(false);
    } else if (isJobDetails === true) {
      onReceiveData(formData, false, 'jobdetails');
    }
  };

  useEffect(() => {
    const { pathname, search } = window.location;
    const jobId = pathname.split("/").pop();
    if (
      Addjobpostingscode === 200 &&
      isJobDetails === false &&
      jobId !== 'jobdetails'
    ) {
      setDisableSubmitBtn(false);
      // var params = { limit: 0, offset: 0 }
      dispatch(_ser.addjobpostingsStartReducer(initalState));
      // dispatch(_ser.listjobpostingsAsync(params, "list"));
      navigate('/ats/layout/jobpostings/landing');
    }
  }, [Addjobpostingscode]);

  return (
    <React.Fragment>
      <Box
        style={{ margin: '0 3.3rem 0 2rem' }}
        component="form"
        sx={{
          bgcolor: 'transparent',
          height: '100%',
          '& > :not(style)': { m: 2, width: '29ch' },
        }}
        noValidate
        autoComplete="off"
      >
        <div
          id="jpn_breadcrumb"
          style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            marginBottom: '40px',
          }}
        >
          <img
            src={process.env.PUBLIC_URL + '/assests/img/applicant.svg'}
            alt=""
          />
          <div style={{ display: 'flex' }}>
            <h4>
              {' '}
              Job Posting /{' '}
              <span style={{ fontWeight: 'normal' }}>New Create Job</span>
            </h4>
          </div>
        </div>
        {viewJob && (
          <PostingsComponent
            componentType="Create"
            input={viewJob}
            iniValue={viewJob}
            onResetValue={onResetValue}
            actions={actionBtns}
            onValidData={GetValidData}
            isJobDetails={isJobDetails}
            disableSubmitBtn={disableSubmitBtn}
          />
        )}
      </Box>
    </React.Fragment>
  );
};

export default PostingsCreate;

const initialDetails = {
  jobCode: '',
  jobTitle: '',
  externalSystemID: '',
  workModel: '',
  jobStatus: '',
  jobType: '',
  clientId: '',
  clientName: null,
  clientBillRate: '',
  payBillRate: '',
  location: '',
  locationDetails: '',
  manager: '',
  teamLead: '',
  recruiters: [],
  priority: '',
  jobDesc: '',
  primarySkills: '',
  secondarySkills: '',
  jobDescForSM: '',
  customerId: 0,
  segmentId: '',
  isClientConfidential: false,
  endClientId: '',
  isEndClientConfidential: false,
};

const actionBtns = [
  {
    variant: 'text',
    style: {
      color: 'red',
      marginRight: '25px',
      fontWeight: 'bolder',
      hover: 'textbold',
    },
    navigateTo: '/ats/layout/jobpostings/landing',
    label: 'Cancel',
    type: 'back',
    class: 'buttonHover',
  },
  {
    variant: 'contained',
    style: {
      backgroundColor: 'var(--primary-bg-color)',
      color: 'var(--primary-background-text-color)',
      borderRadius: '25px',
      width: '6rem',
      fontWeight: '',
    },
    navigateTo: null,
    label: 'Save',
    type: 'submit',
    class: 'buttonHover',
  },
];
